import { useState } from 'react'
import { NavLink } from 'react-router-dom';
import AuthDialog from "./AuthDialog";


export default function Navigation() {
  const [isAuthDialogOpen, setIsAuthDialogOpen] = useState(false);

  const navLinks = [
    { id: 'home-nav', to: '/', label: 'ホーム' },
    { id: 'template-list-nav', to: '/template-list', label: 'テンプレート一覧' },
    { id: 'report-list-nav', to: '/report-list', label: '帳票一覧' },
  ];


  return (
    <>
      <div className="border-bottom my-1 overflow-x-auto">
        <nav aria-label="Tabs" className="d-flex align-items-center px-4">
          {navLinks.map((item) => (
            <NavLink id={item.id} key={item.to} to={item.to} end className="px-2 py-1">
              {item.label}
            </NavLink>
          ))}

          <span id="auth" onClick={() => setIsAuthDialogOpen(true)}>
            ログイン
          </span>

        </nav>
      </div>
      <AuthDialog show={isAuthDialogOpen} onClose={() => setIsAuthDialogOpen(false)} />
    </>
  );
}
